import type { FunctionComponent } from 'react';

import { HummLenderStatus } from './helpers';
import useHummStatus from './useHummStatus';

import Generic from '../../StatusComponent/Generic';
import Specific from '../../StatusComponent/Specific';

const renderHummContent = (state?: HummLenderStatus): JSX.Element => {
  switch (state) {
    case 'error':
      return <Specific.Humm.Error />;
    case 'checking':
      return <Specific.Humm.Checking />;
    case 'referred':
      return <Specific.Humm.Referred />;
    case 'pending':
      return <Specific.Humm.Pending />;
    case 'declined':
      return <Generic.Declined />;
    case 'not_approved':
      return <Generic.Declined />;
    case 'under_review':
      return <Generic.UnderReview />;
    case 'action_required':
      return <Generic.ActionRequired />;
    case 'loading':
      return <Generic.Loading />;
    case 'sign_documents':
      return <Specific.Humm.SignDocuments />;
    case 'deposit':
      return <Generic.Deposit />;
    case 'ready_to_start':
      return <Generic.ReadyToStart />;
    case 'sat_note':
      return <Generic.SatNote />;
    case 'sat_note_delayed':
      return <Generic.SatNoteDelayed />;
    case 'finished':
      return <Generic.Finished />;
    case 'cancelled':
      return <Generic.Cancelled />;
    default:
      return <Generic.Referred />;
  }
};

const HummStatusContent: FunctionComponent = () => {
  const { state } = useHummStatus();
  return <div className="flex flex-col w-full">{renderHummContent(state)}</div>;
};

export default HummStatusContent;
